export default __webpack_public_path__ + "static/media/juego5_v4.d823ef6e.png";